import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import ElliottTowersPage from "./pages/ElliottTowersPage";
import InvestorRelationsPage from "./pages/InvestorRelationsPage";
import ContactPage from "./pages/ContactPage";
import MediaPage from "./pages/MediaPage";
import AppEcosystemPage from "./pages/AppEcosystemPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import InvestorDashboard from "./pages/InvestorDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminPress from "./pages/admin/AdminPress";
import AdminPitchDecks from "./pages/admin/AdminPitchDecks";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/elliott-towers" element={<ElliottTowersPage />} />
              <Route path="/investor-relations" element={<InvestorRelationsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/media" element={<MediaPage />} />
              <Route path="/app-ecosystem" element={<AppEcosystemPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                path="/portal"
                element={<ProtectedRoute><InvestorDashboard /></ProtectedRoute>}
              />
              <Route
                path="/admin"
                element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>}
              />
              <Route
                path="/admin/projects"
                element={<ProtectedRoute role="admin"><AdminProjects /></ProtectedRoute>}
              />
              <Route
                path="/admin/press"
                element={<ProtectedRoute role="admin"><AdminPress /></ProtectedRoute>}
              />
              <Route
                path="/admin/pitch-decks"
                element={<ProtectedRoute role="admin"><AdminPitchDecks /></ProtectedRoute>}
              />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
